<script>
import Jobs from "@/components/jobs/Jobs.vue";
import SearchJob from "@/components/jobs/SearchJob.vue";
import Area from "@/views/home/components/Area.vue";
import Swiper from "swiper";
import "swiper/swiper-bundle.css";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper/core";
SwiperCore.use([Navigation, Pagination, Autoplay]);
export default {
  name: "juridico",
  data() {
    return {
      componentId: null,
      search: "",
      syncdSearch: "",
    };
  },
  head() {
    return this.$head({
      title: "Vagas | ",
    });
  },
  watch: {
    "$route.params.group": function(group) {
      this.getGroup();
      this.start();
    },
  },
  mounted() {
    this.getGroup();
    this.start();
  },
  methods: {
    getGroup() {
      if (this.group == "consultoria-e-contratos") {
        this.componentId = "consultoria-e-contratos";
      } else if (this.group == "patentes") {
        this.componentId = "patentes";
      } else if (this.group == "apoio-administrativo") {
        this.componentId = "apoio-administrativo";
      } else if (this.group == "marcas") {
        this.componentId = "marcas";
      } else if (this.group == "contecioso") {
        this.componentId = "contecioso";
      } else if (this.group == "digital") {
        this.componentId = "digital";
      } else {
        this.componentId = null;
      }
    },
    start() {
      setTimeout(() => {
        var swiper2 = new Swiper(this.$refs["mySwiper"], {
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: {
            nextEl: this.$refs["swiper-button-next"],
            prevEl: this.$refs["swiper-button-prev"],
          },
        });
      }, 150);
    },
  },
  props: {
    group: null,
  },
  components: {
    Jobs,
    SearchJob,
    Area,
  },
};
</script>

<template>
  <div class="jobs-group">
    <div class="banner" :class="group">
      <h1 v-if="componentId == 'consultoria-e-contratos'">
        Consultoria e Contratos
      </h1>
      <h1 v-else-if="componentId == 'patentes'">Patentes</h1>
      <h1 v-else-if="componentId == 'apoio-administrativo'">Administrativo</h1>
      <h1 v-else-if="componentId == 'marcas'">Marcas</h1>
      <h1 v-else-if="componentId == 'contecioso'">Contencioso</h1>
      <h1 v-else-if="componentId == 'digital'">Digital</h1>
      <h1 v-else>Vagas abertas</h1>
    </div>
    <div class="jobs-group__content">
      <div class="container">
        <p v-if="componentId == 'consultoria-e-contratos'">
          Nossa equipe especializada presta consultoria e fornece opiniões,
          pareceres e análises sobre quaisquer temas na matéria de Propriedade
          Intelectual, Direito Digital, Privacidade e Proteção de Dados, Direito
          do Entretenimento e temas correlatos. Além disso, dá suporte e
          assessora empresas dos mais variados ramos de mercado na avaliação,
          elaboração de estratégias, estruturação e negociação de quaisquer
          contratos envolvendo tais matérias.
        </p>
        <p v-else-if="componentId == 'patentes'">
          A equipe de patentes multidisciplinar de G&L auxilia os clientes na
          proteção de invenções das mais diversas áreas tecnológicas. As
          patentes asseguram exclusividade de exploração da invenção ao criador,
          sendo um instrumento fundamental para impulsionar o desenvolvimento de
          novas tecnologias. Nosso time também realiza pesquisas em diversas
          bases de dados de documentos para verificar se determinada invenção
          pode ou não ser patenteada.
        </p>
        <p v-else-if="componentId == 'apoio-administrativo'">
          Aqui vocês poderão apoiar as áreas técnicas. Conheça as oportunidades
          que temos na área administrativa e as possibilidades de atuação…
        </p>
        <p v-else-if="componentId == 'marcas'">
          Nossa equipe tem vasta experiência para aconselhar e assessorar os
          clientes em todas as etapas necessárias, incluindo, desde a estratégia
          prévia, buscas de viabilidade de registro e exploração da marca no
          mercado, até a obtenção do registro de marcas, contencioso
          administrativo no INPI e medidas extrajudiciais protetivas do sinal.
          Tão importante quanto a criação de uma marca é sua adequada proteção.
        </p>
        <p v-else-if="componentId == 'contecioso'">
          A área contenciosa de G&L atua de forma abrangente, assertiva e
          eficiente na representação de nossos clientes na esfera judicial e em
          procedimentos de mediação ou arbitragem, estruturando teses inovadoras
          e sólidas, com base em sua consistente experiência em litígios de alta
          complexidade. Buscamos sempre a solução mais adequada para nossos
          clientes e seus negócios, também atuando fortemente na prevenção e na
          resolução extrajudicial de conflitos.
        </p>
        <p v-else-if="componentId == 'digital'">
          Soluções jurídicas inovadoras para os desafios das novas tecnologias e
          dinâmica social em time colaborativo e criativo.  Atuamos em
          consultoria de alta complexidade envolvendo programas de conformidade
          com a LGPD, assuntos de privacidade e proteção de dados pessoais,
          software, cloud computing, inteligência artificial, e-commerce e
          muitas outras. Igualmente, em contencioso estratégico no setor de
          tecnologia. A área é reconhecida pela combinação de profundidade,
          praticidade, multidisciplinaridade e abordagem inovadora.
        </p>
        <p v-else></p>
        <div
          class="swiper-container swiper mySwiper employee-testimonial"
          ref="mySwiper"
          v-if="componentId == 'consultoria-e-contratos'"
        >
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div>
                <iframe
                  src="https://www.youtube.com/embed/ZtK37HHwfb4"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev" ref="swiper-button-prev"></div>
          <div class="swiper-button-next" ref="swiper-button-next"></div>
        </div>

        <div
          class="swiper-container swiper mySwiper employee-testimonial"
          ref="mySwiper"
          v-else-if="componentId == 'patentes'"
        >
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div>
                <iframe
                  src="https://www.youtube.com/embed/-Onksw_9UeM"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
            <div class="swiper-slide">
              <div>
                <iframe
                  src="https://www.youtube.com/embed/stbPPpmy3G4"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
            <div class="swiper-slide">
              <div>
                <iframe
                  src="https://www.youtube.com/embed/O11ipla2hkY"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev" ref="swiper-button-prev"></div>
          <div class="swiper-button-next" ref="swiper-button-next"></div>
        </div>

        <div
          class="swiper-container swiper mySwiper employee-testimonial"
          ref="mySwiper"
          v-else-if="componentId == 'apoio-administrativo'"
        >
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div>
                <iframe
                  src="https://www.youtube.com/embed/Vll_engC2U8"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
            <div class="swiper-slide">
              <div>
                <iframe
                  src="https://www.youtube.com/embed/iD2LgDX8iws"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
            <div class="swiper-slide">
              <div>
                <iframe
                  src="https://www.youtube.com/embed/Z6pvHgtHsBg"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev" ref="swiper-button-prev"></div>
          <div class="swiper-button-next" ref="swiper-button-next"></div>
        </div>

        <div
          class="swiper-container swiper mySwiper employee-testimonial"
          ref="mySwiper"
          v-if="componentId == 'marcas'"
        >
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div>
                <iframe
                  src="https://www.youtube.com/embed/GbRp5D8Y6yY"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
            <div class="swiper-slide">
              <div>
                <iframe
                  src="https://www.youtube.com/embed/Ca8SKjbinus"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev" ref="swiper-button-prev"></div>
          <div class="swiper-button-next" ref="swiper-button-next"></div>
        </div>

        <div
          class="swiper-container swiper mySwiper employee-testimonial"
          ref="mySwiper"
          v-if="componentId == 'contecioso'"
        >
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div>
                <iframe
                  src="https://www.youtube.com/embed/C8b1KP8jxUI"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
            <div class="swiper-slide">
              <div>
                <iframe
                  src="https://www.youtube.com/embed/cy4o7O__mj4"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev" ref="swiper-button-prev"></div>
          <div class="swiper-button-next" ref="swiper-button-next"></div>
        </div>

        <div
          class="swiper-container swiper mySwiper employee-testimonial"
          ref="mySwiper"
          v-if="componentId == 'digital'"
        >
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div>
                <iframe
                  src="https://www.youtube.com/embed/Hb1do6yCc90"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev" ref="swiper-button-prev"></div>
          <div class="swiper-button-next" ref="swiper-button-next"></div>

          <h2 v-if="componentId">Confira as oportunidades da área</h2>
        </div>
      </div>

      <Area :header="false" class="area" v-if="!componentId" />
      <Jobs :search.sync="syncdSearch" :key="$route.fullPath" v-if="componentId" />
      <div class="nav-item" v-if="!componentId">
        <router-link
          to="/vagas/15298-banco-de-talentos-venha-fazer-parte-de-nosso-time/inscricao"
          class="nav-link"
          >Se você não encontrou uma oportunidade com o seu perfil, <br>
          <strong
            >clique aqui e cadastre-se no nosso Banco de Talentos!</strong
          >
        </router-link>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.area {
  margin-bottom: 5rem !important;
  display: block;
}
h1 {
  color: #fff;
  font-size: 3rem;
  z-index: 99;
  text-transform: uppercase;
  font-weight: 400;
  text-align: center;
}
.jobs-group {
  &__content {
    text-align: center;
    padding: 4rem 0px;
    p {
      max-width: 1000px;
      font-size: 1.3rem;
      margin: 0 auto;
    }
    h2 {
      margin-top: 3rem;
      color: theme-color(primary);
    }
  }
  .employee-testimonial {
    margin: 80px 10px;
    iframe {
      border-radius: 40px;
      border: 10px solid #000;
      height: 280px;
      width: 60%;
      box-shadow: 0px 5px 5px rgb(202, 202, 202);
    }
    .swiper-button-prev,
    .swiper-button-next {
      color: #000;
      border-radius: 100px;
      border: 1px solid #000;
      width: 3rem;
      height: 3rem;
      @media screen and (max-width: 769px) {
        width: 2rem;
        height: 2rem;
        border: 2px solid #f1f1f1;
      }
      &::after {
        font-size: 1.5rem;
        @media screen and (max-width: 769px) {
          font-size: 1rem;
          color: #f1f1f1;
        }
      }
    }
    .swiper {
      transform: translateY(80px);
    }
  }
  .banner {
    width: 100%;
    height: 70vh;
    background: url(../../assets/images/gusmao-labrunie/geral.png) no-repeat
      center center;
    background-size: cover;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &.consultoria-e-contratos {
      background: url(../../assets/images/consultoria@2x.png) no-repeat center
        center;
      background-size: cover;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(#000, 0.5);
      }
    }
    &.patentes {
      background: url(../../assets/images/patentes@2x.png) no-repeat center
        center;
      background-size: cover;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(#000, 0.5);
      }
    }
    &.apoio-administrativo {
      background: url(../../assets/images/administrativo@2x.png) no-repeat
        center center;
      background-size: cover;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(#000, 0.5);
      }
    }
    &.marcas {
      background: url(../../assets/images/marcas@2x.png) no-repeat center center;
      background-size: cover;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(#000, 0.5);
      }
    }
    &.contecioso {
      background: url(../../assets/images/contencioso@2x.png) no-repeat center
        center;
      background-size: cover;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(#000, 0.5);
      }
    }
    &.digital {
      background: url(../../assets/images/digital@2x.png) no-repeat center
        center;
      background-size: cover;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &::after {
        content: "";
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(#000, 0.5);
      }
    }
  }
}

.nav-item {
  a {
    color: #46797B;
    font-size: 20px;
  }
}
</style>
